import type { ReactNode } from 'react'

/**
 * R73 (owner instruction, 2026-10-01): research text never sits in the middle
 * of a page. An item the payload marks research only carries a small marker
 * where it is shown, and the words about it sit in ONE block at the end of the
 * page, which the marker links to. Home, Report, History and Recording detail
 * use these two; State takes them from the State session.
 *
 * The marker says nothing on its own beyond "research, see the end of the
 * page", and the notes say only what the payload marks (`badge`, `validated`,
 * the research-only measures): no scientific sentence is written here.
 */
export const RESEARCH_NOTES_ID = 'research-notes'

export function ResearchMarker({ testid = 'research-marker' }: { testid?: string }) {
  return (
    <a
      className="research-marker"
      href={`#${RESEARCH_NOTES_ID}`}
      data-testid={testid}
      title="Research only — see the research notes at the end of this page"
    >
      <span aria-hidden="true">R</span>
      <span className="visually-hidden">Research only: see the research notes at the end of this page</span>
    </a>
  )
}

export function ResearchNotes({
  children,
  testid = 'research-notes',
  label = 'Research only',
}: {
  children: ReactNode
  testid?: string
  label?: string
}) {
  return (
    <section
      id={RESEARCH_NOTES_ID}
      className="research-notes"
      aria-labelledby={`${RESEARCH_NOTES_ID}-title`}
      data-testid={testid}
      tabIndex={-1}
    >
      <h2 className="research-notes__title" id={`${RESEARCH_NOTES_ID}-title`}>
        <span className="research-marker research-marker--legend" aria-hidden="true">R</span> {label}
      </h2>
      {children}
    </section>
  )
}
